export default __webpack_public_path__ + "static/media/grid-view.inline.723dc401.svg";